import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SmartImage from 'dpl/components/SmartImage';
import { isLessThanBreakpoint } from 'dpl/util/grid';

import imagePlaceholder from 'dpl/assets/image_placeholder.svg';

const IS_LT_MD = isLessThanBreakpoint('md');

/** @param {any} props */
export default function ImagePlaceholderV2({
  className = 'bg-gray-100 br4 ba b--default',
  caption = null
}) {
  return (
    <div
      className={classnames(
        'ImagePlaceholderV2 flex flex-column w-100 h-100 items-center justify-center pv6 ph10 pv12-md ph12-md',
        className
      )}
    >
      <div className="flex overflow-hidden">
        <SmartImage
          src={imagePlaceholder}
          height={IS_LT_MD ? '224px' : '310px'}
          width={IS_LT_MD ? '155px' : '216px'}
        />
      </div>
      {caption && (
        <h6 className="font-20 md:font-24 lh-title mt4 mt6-md tc">{caption}</h6>
      )}
    </div>
  );
}

ImagePlaceholderV2.propTypes = {
  className: PropTypes.string,
  caption: PropTypes.string
};
